<div class="cell flex-1">
  <span class="mr-3 text-opacity-7 d-block mb-3 mr-md-0"><span>{{lot.LotNumber}}</span></span>
</div>
<div class="cell cell-auction-info">
  <div class="row auction-info">
    <div class="d-flex flex-column col-12">
      <h5 class="text-red m-0 text-uppercase">{{lot.WineryName}}</h5>
      <p *ngIf="lot.IsMixedLot">
        <span *ngFor="let mixedLot of lot.AuctionMixedLots" class="d-block">{{mixedLot.Quantity}} x {{mixedLot.WineDefinition?.Wine?.Winery?.Name}} {{mixedLot.WineDefinition?.Wine?.Name}} {{mixedLot.WineDefinition?.Vintage}} ({{mixedLot.WineDefinition?.UnitOfMeasure?.Abbreviation}})</span>
      </p>
      <p *ngIf="!lot.IsMixedLot">{{lot.WineName}}<br>{{ Format([lot.WineVarietyName, lot.WineryRegionName, lot.WineryCountryName]) }} {{lot.Vintage>0 ? lot.Vintage : ''}}</p>
      <div>
        <span *ngIf="!lot.IsMixedLot" class="mr-3 text-opacity-7">{{lot.Quantity}} * {{lot.UnitOfMeasureName}}</span>
        <span class="text-underline text-opacity-7" (click)="ViewImages()">
          <i class="fa fa-camera mr-1" aria-hidden="true"></i>
          <span>View Images</span>
        </span></div>
      <div class="auction-card-footer mt-1 d-flex">
        <ng-container *ngFor="let codedComment of lot.AuctionLotCodedComments;">
          <strong class="text-opacity-7 font-sm lot-quality-codes" *ngIf="codedComment.Quantity > 0" [ngbTooltip]="codedComment.CodedCommentDefinition.Title">
            {{codedComment.CodedCommentDefinition.Code}}
          </strong>
        </ng-container>
        <ng-container *ngFor="let lotAttribute of lot.AuctionLotAttributes;">
          <span class="text-opacity-7 font-sm lot-quality-codes" *ngIf="lotAttribute.Quantity > 0" [ngbTooltip]="lotAttribute.AttributeDefinition.Title">
            {{lot.Quantity>1 ? lotAttribute.Quantity + ' x' : ''}} {{lotAttribute.AttributeDefinition.Code}}
          </span>
        </ng-container>
      </div>
    </div>
  </div>
</div>
<div class="cell d-flex">
  <div class=" mt-3 mt-lg-2 text-height-8 flex-1">
    <h6 class="d-lg-none">Estimate</h6>
    <span>{{lot.EstimatePrice | inDollars}}</span>
  </div>
  <div class=" mt-3 mt-lg-2 text-height-8 flex-1">
    <h6 class="d-lg-none">Winning Bid</h6>
    <div class="d-flex flex-row flex-lg-column">
      <span class="mb-lg-3 mr-3">{{lot.CurrentBid | inDollars}}</span>
      <div><span class="p-1 font-sm text-uppercase status-label" [ngClass]="[ IsWinning ? 'bg-green' : IsOutbid ? 'bg-yellow' : MyAuctionLot.WatchingOnly ? 'bg-secondary' : '']">{{MyAuctionLot.WatchingOnly?"Watching":Status}}</span>
      </div>
    </div>
  </div>
</div>
<div class="cell d-flex">
  <div class="mt-3 mt-lg-2 text-height-8 flex-1">
    <h6 class="d-lg-none">My Autobid</h6>
    <span>{{MyAuctionLot.AutoBidAmount | inDollars}}</span>
  </div>
  <div class="mt-3 mt-lg-2 text-height-8 flex-1">
    <h6 class="d-lg-none">Min Next Bid</h6>
    <span>{{MinimumBid | inDollars}}</span>
  </div>
</div>
<div class="cell mt-3 mt-lg-0 text-height-8 d-lg-flex">
  <h6 class="d-lg-none">New Max Bid (per bottle)</h6>
  <div class="d-flex w-100">
    <div class="form-group mr-3 flex-1">
      <div class="input-group mb-2" *ngIf="LotIsBiddable">
        <div class="input-group-prepend">
          <span class="input-group-text bg-white pl-0">$</span>
        </div>
        <input type="number" class="form-control pl-0 border-0" aria-label="Amount (to the nearest dollar)" [(ngModel)]="newBidAmt" (ngModelChange)="BidChange()" (keyup.enter)="ConfirmBid($event)" (blur)="BidChange(true)">
      </div>
      <span *ngIf="LotIsBiddable && newBidAmt && !NewBidIsValid" class="error-label text-red w-100 text-height-18 font-sm">Invalid amount ({{ MinimumBid | inDollars }}+)</span>
      <!-- <span *ngIf="!newBidAmt || !NewBidIsValid" class="font-sm badge badge-secondary" ngbTooltip="Bid will not be accepted. Bid empty or doesn't meet minimum bid amount.">Not acceptable</span> -->
      <!-- <span *ngIf="LotIsBiddable && NewBidIsValid && !NewBidAmountValidated" (click)="AdjustToIncrement()" class="font-sm badge badge-warning cursor-pointer p-1 font-weight-normal rounded-0" ngbTooltip="Bid meets minimum amount but has not yet been adjusted to the nearest increment.">Tentative</span> -->
      <!-- <span *ngIf="LotIsBiddable && NewBidIsValid && NewBidAmountValidated" class="font-sm badge badge-success p-1 font-weight-normal rounded-0" ngbTooltip="Bid is valid and meets minimum bid amount.">Acceptable</span> -->
      <div *ngIf="processing" @fade class="badge" style="vertical-align: text-bottom;"><i class="fa fa-2x fa-spin fa-spinner"></i></div>
      <span *ngIf="oldBidAmt && NewBidIsValid && NewBidAmountValidated" class="font-sm badge badge-danger p-1 font-weight-normal rounded-0" ngbTooltip="Price adjusted down from {{oldBidAmt | inDollars}}">&darr; {{oldBidAmt | inDollars}}</span>
      <div *ngIf="AuctionHasExpired && !LotIsBiddable" class="font-sm badge badge-danger p-1 font-weight-normal rounded-0 w-100 mt-1" ngbTooltip="This lot is now closed.">Closed</div>
      <div *ngIf="AuctionHasExpired && LotIsBiddable" class="font-sm badge badge-warning p-1 font-weight-normal rounded-0 w-100 mt-1" ngbTooltip="This lot is in right of reply mode.">Right of reply</div>
      <div *ngIf="AuctionHasExpired && LotIsBiddable" class="font-sm badge badge-info p-1 font-weight-normal rounded-0 w-100 mt-1" ngbTooltip="For testing purposes: show the countdown on RoR">{{ RightOfReplyTimer }} seconds</div>

    </div>
    <div class="d-flex flex-column">
      <button class="btn btn-favourite mb-2" tabindex="-1" [ngClass]="{ 'fav-btn-red': MyAuctionLot, 'fav-btn-grey': !stateService.userModelValid() || !MyAuctionLot }" [disabled]="processing || !stateService.userModelValid() || (MyAuctionLot && !MyAuctionLot.WatchingOnly)" [attr.value]="lot.Id" (click)="FavouriteItem($event,lot)">
        <i class="fa fa-eye"></i>
      </button>
      <span *ngIf="!MyAuctionLot.WatchingOnly" class="font-sm btn-hide-item fas fa-eye" (click)="HideList($event,MyAuctionLot)">&nbsp;{{MyAuctionLot.IsHidden?'Show':'Hide'}}</span>
    </div>
  </div>
</div>
